import { mapActions } from 'vuex';

export default {
  props: {
    source: {
      type: Number,
      default: 4,
    },
    isPending: {
      type: Boolean,
      default: false,
    },
    isPopup: {
      type: Boolean,
      default: false,
    },
    theme: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: '',
    },
  },
  computed: {
    isCard() {
      return this.type === 'card';
    },
    classModifiers() {
      return {
        'account-upload-document': true,
        'account-upload-document--modal': this.isPopup,
        'account-upload-document--embedded': !this.isPopup,
        [`account-upload-document--${this.theme}`]: this.theme,
      };
    },
  },
  methods: {
    ...mapActions('user', ['getDocumentUploadLink']),
    onButtonClick() {
      this.getDocumentUploadLink(this.source).then((link) => {
        window.location.href = link;
      });
    },
  },
};
